import { TokenResponse } from "@app/types";
import HttpService from "@core/services/http/http.service";

class _PlayPcrenderService {
  public getTokenForPc(imageId: string, username: string, password: string) {
    return HttpService.post<TokenResponse>(
      `/play-pcrender/get-token-pc/${imageId}`,
      {
        body: { basicauth_username: username, basicauth_password: password },
      }
    );
  }

  public getTokenForCloud(imageId: string, username: string, password: string) {
    return HttpService.post<TokenResponse>(
      `/play-pcrender/get-token-cloud/${imageId}`,
      {
        body: { basicauth_username: username, basicauth_password: password },
      }
    );
  }

  public getDownloadLinkForPc(imageId: string, os: string) {
    return HttpService.get<{ link: string }>(
      `/play-pcrender/pc/${imageId}?os=${os}`
    );
  }

  public getDownloadLinkForCloud(imageId: string, os: string) {
    return HttpService.get<{ link: string }>(
      `/play-pcrender/cloud/${imageId}?os=${os}`
    );
  }
}

const PlayPcrenderService = new _PlayPcrenderService();

export default PlayPcrenderService;
